import { render, staticRenderFns } from "./reset-forgot-password.vue?vue&type=template&id=39f27d58"
import script from "./reset-forgot-password.vue?vue&type=script&lang=js"
export * from "./reset-forgot-password.vue?vue&type=script&lang=js"
import style0 from "./reset-forgot-password.vue?vue&type=style&index=0&id=39f27d58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports